import { CandidateCard } from "@/components/CandidateCard";
import { Candidate } from "@/types/candidate";
import { EntityGrid } from "@/components/common/EntityGrid";
import { useTranslation } from "react-i18next";

interface CandidatesGridProps {
  candidates: Candidate[];
  filteredCandidates: Candidate[];
  isLoading: boolean;
}

export const CandidatesGrid = ({ 
  candidates, 
  filteredCandidates, 
  isLoading 
}: CandidatesGridProps) => {
  const { t } = useTranslation();
  return (
    <EntityGrid
      data={filteredCandidates}
      isLoading={isLoading}
      emptyMessage={t("candidates.list.empty")}
      renderItem={(candidate) => (
        <CandidateCard key={candidate.id} candidate={candidate} />
      )}
    />
  );
};
